import axios from "axios";

const simpleLogUrl =
  "https://skobostats.azurewebsites.net/api/LogError?code=wtYzadJhQiuUCKNnL6FwBUv8kADNMC1cFVEgVaSfMagoagLQbVxjIw==";

export default {
  handleError() {},

  log(type, source, message, additionalData) {
    switch (type) {
      case LogType.MESSAGE:
        axios.post(simpleLogUrl, {
          PartitionKey: source,
          message,
          additionalData: JSON.stringify(additionalData)
        });
        break;
    }
  }
};

export const LogType = {
  ERROR: "error",
  MESSAGE: "message"
};
